import { gql } from 'graphql-request'

export const TOTAL_EBOOK_BANNED = gql`
  query TotalEbookBanned {
    totalEbookBanned
  }
`
